import { Moment } from 'moment'
import { Pager } from '@/store/pager.types'
import { University } from '@/store/master/types'
import { TutorConditions } from '../tutors/types'
import { StudentConditions } from '../students/types'

export const MailTargets = {
  tutor: 'Tutor',
  student: 'Student',
}
export type mailTargetType = keyof typeof MailTargets

export const MailNotifications = {
  mail: 'Mail',
  announce: 'Announce',
}
export type mailNotificationType = keyof typeof MailNotifications

export const MailSendStatuses = {
  unsent: 'Unsent',
  sent: 'Sent',
  canceled: 'Canceled',
}
export type mailSendStatueType = keyof typeof MailSendStatuses

export interface MailsState {
  mails: Mail[]
  pager: Pager
}

export interface Mail {
  id?: string
  subject: string
  status?: mailSendStatueType
  sendAt: Moment
  body?: string
  receivers?: Receiver[]
}

export interface MailForRegisterToStudent {
  studentConditions?: StudentConditions
  sendDate: Moment|null
  subject: string
  body: string
}

export interface MailForRegisterToTutor {
  tutorConditions?: TutorConditions
  sendDate: Moment|null
  subject: string
  body: string
}

/**
 * メール受信者
 */
export interface Receiver {
  type: mailTargetType
  id: string
  name: string
}

/**
 * メール一覧検索条件
 */
export interface MailsConditions {
  subject: string|null
  statuses: mailSendStatueType[]
  university: University|null
  from: Moment|null
  to: Moment|null
  target: {
    type: mailTargetType
    word: string
  }|null
}
